module.exports = [{
      plugin: require('/home/jenkins/workspace/Release_android-china-site_main/node_modules/gatsby-plugin-emotion/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/jenkins/workspace/Release_android-china-site_main/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
